import React, { useState, useEffect, createContext, useCallback } from 'react';
import { NavType } from '@/components/navbar';
import { useRouter } from 'next/router';
import axios from 'axios';
import Head from 'next/head';

type Time = {
  start_time: string,
  end_time: string,
  address: string
}

interface IndexContextProps {
  nav: NavType[];
  setNav: (nav: NavType[]) => void;
  time: Time;
  setTime: (time: Time) => void;
  lang: 'cn' | 'en';
  setLang: (lang: 'cn' | 'en') => void;
  isHeadFoot: boolean;
  setIsHeadFoot: (isHeadFoot: boolean) => void;
}

interface IProps {
  children: JSX.Element;
}

export const IndexContext = createContext<IndexContextProps>({} as IndexContextProps);

export const IndexContextProvider = ({ children }: IProps): JSX.Element => {
  const [nav, setNav] = useState<NavType[]>();
  const [time, setTime] = useState<Time>({
    start_time: '',
    end_time: '',
    address: ''
  })
  const [lang, setLang] = useState<'cn' | 'en'>('cn')
  const [isHeadFoot, setIsHeadFoot] = useState<boolean>(true)
  const router = useRouter()

  const changeLange = useCallback((_lang: 'cn' | 'en') => {
    if (_lang === lang) {
      return
    } else {
      if (router.asPath.slice(0, 3) === '/en') {
        const path = router.asPath.slice(3) || '/'        
        router.push(path, path, {
          shallow: true
        })
      } else {
        const path = '/en' + (router.asPath == '/' ? '' : router.asPath)        
        router.push(path, path, {
          shallow: true
        })
      }
      setLang(_lang)
    }
  }, [lang, router])

  useEffect(() => {
    if (router.asPath.slice(0, 3) === '/en') {
      setLang('en')
    } else {
      setLang('cn')
    }
  }, [router])

  return (
    <IndexContext.Provider
      value={{
        //@ts-ignore
        nav,
        time,
        lang,
        isHeadFoot,
        setIsHeadFoot: (_isHeadFoot: boolean): void => {
          setIsHeadFoot(_isHeadFoot)
        },
        setTime: (_time: Time): void => {
          setTime(_time)
        },
        setLang: (_lang: 'cn' | 'en') => {
          changeLange(_lang)
        },
        setNav: (current: NavType[]): void => {
          setNav(current);
        },
      }}
    >
      {children}
    </IndexContext.Provider>
  );
};
